import { ActionType } from 'flow/store/engine/constants';
import type {
  Action, PublishedAttribute,
} from 'flow/store/engine/types';

export function getActionPublishedAttributeToken(action?: Action) {
  if (action?.type !== ActionType.INPUT && action?.type !== ActionType.OUTPUT) {
    return '';
  }

  return action.input?.publishedAttributeToken ?? action.output?.publishedAttributeToken;
}

export function getPublishedDetails(action: Action): PublishedAttribute | null {
  if (!getActionPublishedAttributeToken(action)) return null;
  switch (action.type) {
    case ActionType.INPUT:
      return Object.hasOwn(action.input, 'publishedDetails') ? action.input.publishedDetails : null;
    case ActionType.OUTPUT:
      return Object.hasOwn(action.output, 'publishedDetails') ? action.output.publishedDetails : null;
    default:
      return null;
  }
}
